// 意见反馈类型
enum FeedbackTypeEnum {
  Feedback = 1, // 个人中心
  Search = 2, // 搜索结果页
  Recommend = 3, // 推荐结果页
  Product = 4, // 商详
  Recommend_Feedback = 5, // 推荐反馈
  Search_Feedback = 6, // 搜索反馈
  Category_Feedback = 7, // 类目搜索反馈
  Login_Feedback = 8, // 注册登录反馈
  ProductGeneral = 9, // 商详-一般问题
  ProductTranslate = 10, // 商详-翻译问题
  ProductReviewGeneral = 11, // 商详评论-一般问题
  ProductReviewTranslate = 12, // 商详评论-翻译问题
  Marketing_Feedback = 13, // 营销反馈
  ScreenShot = 14, // 截图
}

export default FeedbackTypeEnum;
